module.exports = __webpack_public_path__ + "media/images/icons/flags/FJ-10f31a90be4d1deb068251899c091554.svg";